import { Select } from "./Item/Select";
import { Dropdown } from "./Item/Dropdown";
import { Text } from "./Item/Text";
import { MultiText } from "./Item/MultiText";
import { HAFile } from "./Item/HAFile";
import { MultiMedia } from "./Item/MultiMedia";
import { Button } from "./Item/Button";
import { Checkbox } from "./Item/Checkbox";
import { Bool } from "./Item/Bool";
import { MultiCheck } from "./Item/MultiCheck";
import { FormItem } from "./Item/FormItem";

type TagFactory = (d: Map<any, any>) => FormItem;

export class FormItemRegistry {
    private static readonly _map: Map<string, TagFactory> = (() => {
        const m = new Map<string, TagFactory>();
        m.set("slct",     (d) => new Select(d));
        m.set("mslct",    (d) => new Select(d));
        m.set("dropdown", (d) => new Dropdown(d));
        m.set("txtl",     (d) => new Text(d));
        m.set("txt",      (d) => { d.set("textarea", 1); return new Text(d); });
        m.set("mtxt",     (d) => new MultiText(d));
        m.set("fs",       (d) => new HAFile(d));
        m.set("mm",       (d) => new MultiMedia(d));
        m.set("btn",      (d) => new Button(d));
        m.set("checkbox", (d) => new Checkbox(d));
        m.set("bool",     (d) => new Bool(d));
        m.set("mchk",     (d) => new MultiCheck(d));
        return m;
    })();

    public static createTag(ft: string, data: Map<any, any>): FormItem | undefined {
        const factory = FormItemRegistry._map.get(ft);
        return factory ? factory(data) : undefined;
    }
}
